<template>
    <div class="flex relative left-2">
        <div
          class="flex self-center relative items-center justify-center rounded-full text-white"
          :class="cssClass"
          :style="{
            width: `${width}px`,
            height: `${height}px`,
            backgroundColor: backgroundColor,
          }"
        >
          <span
            class="text-xs"
            :class="textClass"
            :data-testid="`badge-value-${value}`"
            >{{ value }}</span
          >
        </div>
    </div>
</template>

<script>
export default {
  props: {
    cssClass: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      required: true,
    },
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
    backgroundColor: {
      type: String,
      default: "#1E264E",
    },
    textClass: {
      type: String,
      default: "text-white-500",
    },
  },
};
</script>

